import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import origami1 from './pictures/origami1.JPG';
import origami2 from './pictures/origami2.JPG';
import origami3 from './pictures/origami3.JPG';
import origami4 from './pictures/origami4.JPG';

const Origami= () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC x SWECC Origami Competition!</h2>
                    <p class="site-post-meta">June 3, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

Thank you so much for showing up to our Origami Night collab event with SWECC! ⭐️📄

<br></br>
                    <br></br>

We all loved the cute stars y’all made and we had so much fun watching the winning group unleash their creative skills in the 2nd round. Congratulations to the winner and we hope you enjoy your new Hello Kitty plush! 😸

<br></br>
                    <br></br>
                    </p>
                    <img src={origami1} alt="origami1 "/>
                    <img src={origami2} alt="origami2"/>
                    <img src={origami3} alt="origami3"/>
                    <img src={origami4} alt="origami4"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Origami;
